<template>
  <div
    :class="{ 'bg-white': !nightMode, 'bg-dark': nightMode }"
    class="hero-section p-st"
  >
    <div
      class="container section-inner"
      data-aos="fade"
      data-aos-once="true"
      data-aos-duration="800"
    >
      <div class="row align-items-center">
        <div class="col-xl-6 col-md-6 col-sm-12 text-center order-md-2 order-1">
          <img :src="picture" alt="Usama Khurshid" class="hero-img" />
        </div>
        <div class="col-xl-6 col-md-6 col-sm-12 order-md-1 order-2">
          <h1
            class="hero-title"
            :class="{ pgray: !nightMode, 'text-light': nightMode }"
          >
            Full Stack Developer
          </h1>
          <p
            class="hero-desc"
            :class="{ 'text-light': nightMode }"
            v-html="description"
          ></p>
          <div class="hero-links">
            <a
              href="#"
              @click.prevent="open('linkedin')"
              class="btn-hero"
              v-tooltip.bottom="'LinkedIn'"
              aria-label="LinkedIn"
            >
              <i class="fab fa-linkedin"></i>
            </a>
            <a
              href="#"
              @click.prevent="open('github')"
              class="btn-hero"
              v-tooltip.bottom="'GitHub'"
              aria-label="GitHub"
            >
              <i class="fab fa-github"></i>
            </a>
            <a
              v-if="website"
              href="#"
              @click.prevent="open('website')"
              class="btn-hero"
              v-tooltip.bottom="'Website'"
              aria-label="Website"
            >
              <i class="fas fa-globe"></i>
            </a>
            <a
              href="#"
              @click.prevent="open('resume')"
              class="btn-hero"
              v-tooltip.bottom="'Resume'"
              aria-label="Resume"
            >
              <i class="fa fa-file-alt"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import info from "../../info";

export default {
  name: "Home",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      picture: info.flat_picture,
      description: info.description,
      name: info.name,
      linkedin: info.links.linkedin,
      github: info.links.github,
      website: info.links.website,
      resume: info.links.resume,
    };
  },
  methods: {
    open(link) {
      switch (link) {
        case "linkedin":
          window.open(this.linkedin, "_blank");
          break;
        case "github":
          window.open(this.github, "_blank");
          break;
        case "website":
          window.open(this.website, "_blank");
          break;
        case "resume":
          window.open(this.resume, "_blank");
          break;
      }
    },
  },
};
</script>

<style scoped>
.hero-section {
  padding: 4rem 0 5rem;
}

.section-inner {
  max-width: 1200px;
  margin: 0 auto;
}

.hero-title {
  font-size: clamp(1.75rem, 4vw, 2.25rem);
  font-weight: 600;
  letter-spacing: -0.02em;
  margin-bottom: 1.25rem;
}

.hero-desc {
  font-size: 1rem;
  line-height: 1.65;
  margin-bottom: 1.75rem;
  max-width: 520px;
}

.hero-img {
  max-width: 280px;
  width: 100%;
  height: auto;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

.hero-links {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.btn-hero {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid var(--color-accent, #475569);
  color: var(--color-accent, #475569);
  transition: all 0.25s ease;
  text-decoration: none;
}

.btn-hero:hover {
  background: var(--color-accent, #475569);
  color: #fff;
  border-color: var(--color-accent, #475569);
}

.btn-hero i {
  font-size: 1.1rem;
}

@media only screen and (max-width: 768px) {
  .hero-section {
    padding: 2rem 0 3rem;
  }

  .hero-img {
    max-width: 200px;
    margin-bottom: 1.5rem;
  }

  .hero-title {
    text-align: center;
  }

  .hero-desc {
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }

  .hero-links {
    justify-content: center;
  }
}
</style>
